<template>
    <div class="edit-row">
        <div class="details-title">{{ event.name }}</div>
        <div>
            <el-button
                type="primary"
                class="gcmcn-primary-btn small"
                :loading="loading"
                @click="editDetails"
            >Edit</el-button>
            <el-button
                v-if="!eventHasRelatedFeed"
                slot="reference"
                type="danger"
                class="gcmcn-danger-btn small"
                :loading="loading"
                @click="showModal = true"
            >Delete</el-button>
        </div>
        <default-modal
            :show="showModal"
            :closeOnClickModal="false"
            @close="closeModal"
        >
            <div style="word-break: break-word;">
                <h2 class="rights-management-modal-title">
                    Confirmation Required
                </h2>
                <div class="delete-event-warning-message">You are going to archive event <span>'{{ event.name }}'</span></div>
                <div class="delete-event-message">Please confirm your intention, input <span>'{{ event.name }}'</span> to proceed or close this modal to cancel.</div>
                <div class="gcmcn-form-input">
                    <el-input
                        size="mini"
                        v-model="eventToDelete"
                    ></el-input>
                </div>
                <div class="modal-action-button-container">
                    <el-button
                        class="delete-event-cancel-btn"
                        type="text"
                        small
                        :loading="loading"
                        @click="closeModal"
                    >Cancel</el-button>
                    <el-button
                        class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                        :disabled="!inputDeleteEventMatchEventName"
                        :loading="loading"
                        @click="deleteEvent"
                    >Validate</el-button>
                </div>
            </div>
        </default-modal>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';

export default {
    components: {
        DefaultModal
    },
    props: {
        event: {
            type: Object,
            required: true
        },
        relatedFeeds: {
            type: Array,
            required: true
        },
    },

    data: function(){
        return {
            loading: false,
            showModal: false,
            eventToDelete: '',
        };
    },

    computed: {
        ...mapGetters([
            'eventsByUid',
        ]),
        eventHasRelatedFeed (){
            return this.relatedFeeds.length > 0;
        },
        inputDeleteEventMatchEventName () {
            return this.event.name === this.eventToDelete;
        },
    },

    mounted: function(){
    },

    methods: {
        editDetails() {
            this.$emit('editEvent');
        },

        hideSubscribePopover() {
            if (this.$refs['popover']) {
                this.$refs['popover'].showPopper = false;
            }
        },

        closeModal (){
            this.eventToDelete = '';
            this.showModal = false;
        },

        deleteEvent (){
            this.loading = true;
            this.$store.dispatch('patchItem', {
                item: {
                    archived: true,
                    url: this.event.url,
                    uid: this.event.uid,
                },
                model: 'events',
            }).then(() => {
                this.$emit('on-event-deleted', () => {
                    this.closeModal();
                    this.$message({
                        message: `Event archived!`,
                        type: 'success'
                    });
                });
            }).catch((e) => {
                console.error(e);
                this.$message.error(`Error on event archiving`);
            }).finally(() => {
                this.loading = false;
            });
        },
    },
};
</script>

<style lang="scss">
.event-details {
    background-color: #333;
    border-radius: 4px;
    padding: 15px;
    color: #EEE;
    .details-container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
        .details-content {
            margin-top: 10px;
            width: 100%;
            .region, .group {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                .details-label {
                    font-size: 14px;
                    padding: 0;
                }
                .details-value {
                    font-size: 14px;
                    font-weight: 500;
                    margin-left: 10px;
                }
            }
        }
    }
}
.delete-event-warning-message{
    color: #F56C6C;
    margin: 10px 0;
    text-transform: none;
    span{
        font-style: italic;
    }
}
.delete-event-message{
    color: #bbb;
    margin-bottom: 10px;
    text-transform: none;
    span{
        color: #F56C6C;
    }
}
.delete-event-cancel-btn{
    color: #bbb;
}
.delete-event-confirm-btn{
    &.is-disabled{
        background-color: #333333;
        border-color: #333333;
        color: #666;
    }
    background-color: #bbb;
    border-color: #bbb;
    color: #444;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Events/eventDetails.vue